import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["questions", "submitButton"]

  connect() {
    this.validateForm()
    this.addChangeListeners()
  }

  addChangeListeners() {
    const inputs = this.questionsTarget.querySelectorAll('input[type="radio"]')
    inputs.forEach(input => {
      input.addEventListener("change", () => {
        this.validateForm()
      })
    })
  }

  validateForm() {
    const requiredQuestions = ["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9", "q10"]
    const additionalQuestions = ["planning_discuss", "glasses_advised", "medications_discuss", "devices_explained", "card_delivered"]
    let allAnswered = true

    // Vérifier les questions principales du phototype
    requiredQuestions.forEach(questionName => {
      const questionInputs = this.questionsTarget.querySelectorAll(`input[name="phototype_questionnaire[${questionName}]"]`)
      const isAnswered = Array.from(questionInputs).some(input => input.checked)

      if (!isAnswered) {
        allAnswered = false
      }
    })

    // Vérifier les questions annexes
    additionalQuestions.forEach(questionName => {
      const questionInputs = this.questionsTarget.querySelectorAll(`input[name="additional_questions[${questionName}]"]`)
      const isAnswered = Array.from(questionInputs).some(input => input.checked)

      if (!isAnswered) {
        allAnswered = false
      }
    })

    // Enable/disable submit button based on form validation
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !allAnswered

      if (allAnswered) {
        this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
        this.submitButtonTarget.classList.add("hover:bg-blue-700")
      } else {
        this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
        this.submitButtonTarget.classList.remove("hover:bg-blue-700")
      }
    }
  }
}
